module.exports = __webpack_public_path__ + "static/Gotham-Bold-46e967b815ca51f5f3d477f178662f51.ttf";